import { render, staticRenderFns } from "./editor_unsplash_images.vue?vue&type=template&id=22952494&scoped=true"
import script from "./editor_unsplash_images.vue?vue&type=script&lang=js"
export * from "./editor_unsplash_images.vue?vue&type=script&lang=js"
import style0 from "./editor_unsplash_images.vue?vue&type=style&index=0&id=22952494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22952494",
  null
  
)

export default component.exports